import request from '@/utils/request'

/**
 * 查询满免配送配置（运营态，REQ20260907013）
 * 服务码 admin.order.queryFreeDeliveryConfig
 * @returns {Promise} Promise对象，data = {threshold, platformSharePercent, enabled}
 */
export function queryFreeDeliveryConfig() {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.order.queryFreeDeliveryConfig',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存满免配送配置（运营态，REQ20260907013，整单覆盖写 c_mapping 两个 key 并即时刷新缓存）
 * @param {Object} data 保存报文（{threshold: 阈值元、空=关闭, platformSharePercent: 比例0-100、空=0}）
 * @returns {Promise} Promise对象
 */
export function saveFreeDeliveryConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.order.saveFreeDeliveryConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
